import React, { useState } from "react";
import {
  Button,
  Card,
  CardBody,
  Col,
  Input,
  Label,
  Modal,
  ModalBody,
  ModalHeader,
  Row,
  UncontrolledTooltip,
} from "reactstrap";
import AddCredits from "../SideComponents/AddCredits";
import { useDispatch, useSelector } from "react-redux";
import {
  getTenantPlanDetails,
  getPlan,
  getTenantCustomPlan,
} from "action/plans";
import { useLocation } from "react-router-dom";
import { cyanBlue } from "../constants/Constants";
import { GetPlanDetails } from "constants/ReducerConstants/Constants";
import { convertUTCToLocal } from "pages/CommonFunctions";
import Select from "react-select";
import { getPlansList } from "action/plans";
import moment from "moment";
import { updateTenantPlanEndDate } from "action/plans";
import CreateCustomPlan from "../SideComponents/CreateCustomPlan";
import Swal from "sweetalert2";
import { API_OPTIONS, SMTP_OPTIONS } from "pages/Common/Constants";

function PlanDetails() {
  const [open, setOpen] = React.useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const plans_List = useSelector((state) => state.planReducer.plansList);
  const [isCustomPlanModalOpen, setIsCustomPlanModalOpen] = useState(false);
  const [showLoaderOnCreatePlanBtn, setLoaderOnCreatePlanBtn] = useState(false);
  const handleOpenCustomPlanModal = () => setIsCustomPlanModalOpen(true);
  const handleCloseCustomPlanModal = () => setIsCustomPlanModalOpen(false);
  const location = useLocation();
  const id = location.state?.id;
  const dispatch = useDispatch();
  const role = JSON.parse(localStorage.getItem("p"))?.role;
  const tenantPlanData = useSelector(
    (state) => state.TenantDetailsReducer.planDetails,
  );
  const [tenantData, setTenantData] = React.useState(tenantPlanData);
  const planData = useSelector((state) => state.planReducer.planData);
  const [isPlansLoading, setIsPlansLoading] = useState(true);
  const [plansError, setPlansError] = useState(null);
  const [isEdit, setIsEdit] = React.useState(false);
  const [planOptions, setPlanOptions] = useState([]);
  const [currencyOptions, setCurrencyOptions] = useState([]);
  const [data, setData] = useState({
    plan: null,
    currency: null,
  });
  const [formError, serError] = useState({
    plan: null,
    currency: null,
  });
  const [isApiEdit, setIsApiEdit] = useState(false);
  const [isSmtpRotationEdit, setIsSmtpRotationEdit] = useState(false);

  React.useEffect(() => {
    getPlansList(dispatch);
  }, [dispatch]);

  React.useEffect(() => {
    setIsPlansLoading(true);
    setPlansError(null);

    if (plans_List?.code === 200 && plans_List.data?.Plan?.length > 0) {
      const formattedPlans = plans_List.data.Plan.map((plan) => ({
        label: plan.name,
        value: plan.ID,
      }));
      const formattedCurrency =
        tenantData?.data?.currency === ""
          ? [
              {
                label: "USD",
                value: "USD",
              },
              {
                label: "INR",
                value: "INR",
              },
            ]
          : [
              {
                label: tenantData?.data?.currency,
                value: tenantData?.data?.currency,
              },
            ];
      setCurrencyOptions(formattedCurrency);
      setPlanOptions(formattedPlans);
      setIsPlansLoading(false);
    } else {
      setPlansError("Failed to load plans. Please try again.");
      setIsPlansLoading(false);
    }
  }, [plans_List, tenantData]);

  React.useEffect(() => {
    setTenantData(tenantPlanData);
  }, [tenantPlanData]);

  React.useEffect(() => {
    if (tenantData) {
      if (tenantData?.code === 200) {
        setError(false);
        setIsLoading(false);
      } else if (tenantData.code) {
        setError(true);
        setIsLoading(false);
      } else {
        setError(false);
        setIsLoading(true);
      }
    } else {
      setError(false);
      setIsLoading(true);
    }
  }, [tenantData]);

  React.useEffect(() => {
    if (open) getPlan(tenantData?.data?.planID, dispatch);
  }, [dispatch, open]);

  React.useEffect(() => {
    dispatch({ type: GetPlanDetails, payload: {} });
    getTenantPlanDetails(dispatch, id);
  }, [dispatch]);

  const handlePlanType = (type) => {
    if (type === "STANDARD") return "Monthly";
    else return "Custom";
  };

  const toggle = () => {
    setIsOpen(!isOpen);
    serError({
      plan: null,
      currency: null,
    });
    setData({
      plan: null,
      currency: null,
    });
  };

  const handleChange = (name, value) => {
    setData((prev) => ({ ...prev, [name]: value }));
    handleError(name, value);
  };

  const handleError = (name, value) => {
    serError((prev) => ({ ...prev, [name]: value ? false : true }));
  };
  const handleDisable = () => {
    return Object.values(data).some((value) => !value);
  };

  //on Click of create custom plan first checking if already a custom plan exist
  // if exist then not allowing to create a new custom plan
  const onClickCreateCustomPlan = async () => {
    setLoaderOnCreatePlanBtn(true);
    const customPlanResponse = await getTenantCustomPlan(
      dispatch,
      `?tenantID=${id}&status=["PENDING"]`,
    );
    if (
      customPlanResponse &&
      customPlanResponse.code === 200 &&
      customPlanResponse.data.planID !== 0
    ) {
      Swal.fire({
        title: "Custom Plan Creation Unavailable",
        text: "To create a new custom plan, please delete the existing one first.",
        icon: "info",
        showConfirmButton: true,
        confirmButtonColor: cyanBlue,
        // timer: 3000,
      });
    } else {
      handleOpenCustomPlanModal();
    }
    setLoaderOnCreatePlanBtn(false);
  };
  // const handleClickOnEdit = () => {
  //   setEditDate(true);
  // };
  // Inside your component
  const handleDateChange = (e) => {
    const { value } = e.target;
    setTenantData((prev) => ({
      ...prev,
      data: {
        ...prev.data,
        planRenewalDate: value,
      },
    }));
  };

  const updateData = async () => {
    const currentDate = moment(tenantPlanData.data?.planRenewalDate).format(
      "YYYY-MM-DD",
    );
    const newDate = moment(tenantData.data?.planRenewalDate).format(
      "YYYY-MM-DD",
    );
    const currentAPI = tenantPlanData.data?.apiAllowed;
    const newAPI = tenantData.data?.apiAllowed;

    const currentSMTPRotation = tenantPlanData.data?.smtpRotationEnabled;
    const newSMTPRotation = tenantData.data?.smtpRotationEnabled;

    //If nothing changed do nothing
    if (
      currentDate === newDate &&
      currentAPI === newAPI &&
      currentSMTPRotation === newSMTPRotation
    ) {
      setIsEdit(false);
      setIsApiEdit(false);
      setIsSmtpRotationEdit(false);
      return;
    }
    setIsLoading(true);

    const payload = {};

    // Send date only if changed
    if (currentDate !== newDate) {
      payload.endDate = newDate;
    }

    // Send API support only if changed
    if (currentAPI !== newAPI) {
      payload.enableAPI = newAPI;
    }

    //send the smtp rotation only if changes
    if (currentSMTPRotation !== newSMTPRotation) {
      payload.enabledSMTPRotation = newSMTPRotation;
    }
    const res = await updateTenantPlanEndDate(id, payload);

    if (res.code === 200) {
      setIsEdit(false);
      setIsApiEdit(false);
      setIsSmtpRotationEdit(false);
      getTenantPlanDetails(dispatch, id);
      Swal.fire({
        icon: "success",
        title: "Success",
        text: res?.message || "Plan updated successfully.",
        timer: 3000,
        showConfirmButton: false,
      });
    } else {
      Swal.fire({
        title: "Something Went Wrong",
        text: res?.message || "Internal server error.",
        icon: "error",
        timer: 3000,
        showConfirmButton: false,
      });
    }
    setIsLoading(false);
  };

  return (
    <>
      <Modal
        isOpen={isOpen}
        toggle={toggle}
        centered={true}
        contentClassName={""}
      >
        <ModalHeader toggle={() => toggle()}>Add Plan</ModalHeader>
        <ModalBody className="pt-0">
          <Row lg="12" md="12" sm="12">
            <Col className="pb-4" lg="12" md="12" sm="12">
              <Label className="h4">Select Plan</Label>
              <Select
                options={isPlansLoading ? [] : planOptions}
                placeholder={
                  isPlansLoading ? "Loading plans..." : "Select Plan"
                }
                isSearchable
                fullWidth
                styles={customStyles}
                onChange={(e) => handleChange("plan", e)}
                value={data.plan || ""}
                onBlur={() => handleError("plan", data.plan)}
                isDisabled={isPlansLoading || !!plansError}
              />
              {plansError && (
                <small className="text-danger">{plansError}</small>
              )}
              {formError?.plan && (
                <small className="text-danger">This field is required</small>
              )}
            </Col>
            <Col className="pb-4" lg="12" md="12" sm="12">
              <Label className="h4">Select Currency</Label>
              <Select
                options={isPlansLoading ? [] : currencyOptions}
                placeholder={
                  isPlansLoading ? "Loading Currency..." : "Select Currency"
                }
                isSearchable
                fullWidth
                styles={customStyles}
                onChange={(e) => handleChange("currency", e)}
                value={data.currency || ""}
                onBlur={() => handleError("currency", data.currency)}
                isDisabled={isPlansLoading || !!plansError}
              />
              {plansError && (
                <small className="text-danger">{plansError}</small>
              )}

              {formError?.currency && (
                <small className="text-danger">This field is required</small>
              )}
            </Col>
          </Row>
          <Button
            onClick={() => toggle()}
            disabled={handleDisable()}
            outline
            color="info"
            style={{ float: "inline-end" }}
          >
            Save
          </Button>
        </ModalBody>
      </Modal>
      <Card style={styles.cardStyle}>
        <CardBody>
          <Col lg="12" className="mb-2 pb-3">
            <Row lg="12" md="12" sm="12">
              <Col lg="12" md="12" sm="12">
                <Col lg="12" md="12" sm="12">
                  <Row className="pb-2 justify-content-between">
                    <h3>Plan Details</h3>
                    <div>
                      {role === "SUPER_ADMIN" && !isLoading && !error && (
                        <Button
                          outline
                          color="info"
                          onClick={() => onClickCreateCustomPlan()}
                        >
                          {showLoaderOnCreatePlanBtn ? (
                            <i className="fa fa-spinner fa-spin fa-lg text-info px-5" />
                          ) : (
                            "Create Custom Plan"
                          )}
                        </Button>
                      )}
                      {!isLoading && !error && (
                        <Button outline color="info" onClick={handleOpen}>
                          Add Credits
                        </Button>
                      )}
                    </div>
                  </Row>
                  {isLoading ? (
                    <div style={styles.loaderContainer}>
                      <i
                        className="fa fa-spinner fa-spin fa-2xl"
                        style={styles.loaderColor}
                      />
                    </div>
                  ) : error ? (
                    <>
                      <div style={styles.loaderContainer}>
                        Something went wrong
                      </div>
                    </>
                  ) : (
                    <>
                      <Row lg="12" md="12" sm="12">
                        <Col lg="4" md="4" sm="4">
                          <Label className="form-control-label">
                            Plan Name
                          </Label>
                          <p>{tenantData.data?.planName}</p>

                          <Label className="form-control-label">
                            Subscription ID
                          </Label>
                          <p>{tenantData?.data?.subscriptionID || "N/A"}</p>

                          <Label className="form-control-label">
                            Total Credits
                          </Label>
                          <p>{tenantData.data?.allocatedCredits}</p>
                          <Label className="form-control-label">
                            API Support
                          </Label>

                          {!isApiEdit ? (
                            <div className="d-flex align-items-center">
                              <p className="mb-0">
                                {tenantData.data?.apiAllowed}
                              </p>

                              <i
                                className="fas fa-edit text-info ml-2"
                                style={styles.iconStyle}
                                onClick={() => setIsApiEdit(true)}
                              />
                            </div>
                          ) : (
                            <div className="w-25">
                              <Select
                                options={API_OPTIONS}
                                value={{
                                  label: tenantData.data?.apiAllowed,
                                  value: tenantData.data?.apiAllowed,
                                }}
                                onChange={(e) => {
                                  setTenantData((prev) => ({
                                    ...prev,
                                    data: {
                                      ...prev.data,
                                      apiAllowed: e.value,
                                    },
                                  }));
                                }}
                                styles={customStyles}
                              />
                            </div>
                          )}
                        </Col>
                        <Col lg="4" md="4" sm="4">
                          <Label className="form-control-label">
                            Billing Cycle
                          </Label>
                          <p>{handlePlanType(tenantData.data?.planType)}</p>
                          <Label className="form-control-label">
                            Used Credits
                          </Label>
                          <p>{tenantData.data?.UsedCredits}</p>
                          <Label className="form-control-label">
                            Last Renewed on
                          </Label>
                          <p>
                            {convertUTCToLocal(tenantData.data?.planStartDate)}
                          </p>

                          <Label className="form-control-label">
                            SMTP Rotation 
                          </Label>

                          {!isSmtpRotationEdit ? (
                            <div className="d-flex align-items-center">
                              <p className="mb-0">
                                {tenantData.data?.smtpRotationEnabled}
                              </p>

                              <i
                                className="fas fa-edit text-info ml-2"
                                style={styles.iconStyle}
                                onClick={() => setIsSmtpRotationEdit(true)}
                              />
                            </div>
                          ) : (
                            <div className="w-25">
                              <Select
                                options={SMTP_OPTIONS}
                                value={{
                                  label: tenantData.data?.smtpRotationEnabled,
                                  value: tenantData.data?.smtpRotationEnabled,
                                }}
                                onChange={(e) => {
                                  setTenantData((prev) => ({
                                    ...prev,
                                    data: {
                                      ...prev.data,
                                      smtpRotationEnabled: e.value,
                                    },
                                  }));
                                }}
                                styles={customStyles}
                              />
                            </div>
                          )}
                        </Col>
                        <Col lg="4" md="4" sm="4">
                          <Label className="form-control-label">
                            Plan Cost
                          </Label>
                          <p>
                            {tenantData.data?.planID !== 1
                              ? tenantData.data?.currency === "INR"
                                ? `₹${tenantData.data?.planInrRate}`
                                : tenantData.data?.currency === "USD"
                                  ? `$${tenantData.data?.planUsdRate}`
                                  : tenantData.data?.planUsdRate
                              : "Free"}
                          </p>
                          <Label className="form-control-label">
                            Remaining Credits
                          </Label>
                          <p>{tenantData.data?.availableCredits}</p>
                          <Label className="form-control-label">
                            Next Renewal on
                          </Label>
                          {!isEdit ? (
                            <div className="d-flex align-items-center">
                              <p className="mb-0">
                                {convertUTCToLocal(
                                  tenantData.data?.planRenewalDate,
                                )}
                              </p>
                              <a
                                className="table-action table-action-warning ml-2"
                                id="tooltipEdit"
                                style={styles.iconStyle}
                                onClick={(e) => setIsEdit(true)}
                              >
                                <i className="fas fa-edit text-info" />
                              </a>
                              <UncontrolledTooltip
                                delay={0}
                                target="tooltipEdit"
                              >
                                Edit Calendar
                              </UncontrolledTooltip>
                            </div>
                          ) : (
                            <Input
                              className="w-50"
                              name="endDate"
                              type="date"
                              value={
                                tenantData.data?.planRenewalDate
                                  ? moment(
                                      tenantData.data.planRenewalDate,
                                    ).format("YYYY-MM-DD")
                                  : ""
                              }
                              placeholder="End Date"
                              onChange={handleDateChange}
                              min={moment().format("YYYY-MM-DD")}
                            />
                          )}
                        </Col>
                      </Row>
                    </>
                  )}
                </Col>
                {(isEdit || isApiEdit || isSmtpRotationEdit) && (
                  <div className="d-flex justify-content-end">
                    <Button color="info" onClick={updateData}>
                      Save
                    </Button>
                  </div>
                )}
              </Col>
              <AddCredits
                handleClose={handleClose}
                isOpen={open}
                tenantId={id}
                currency={tenantData?.data?.currency}
                ratePerCredit={
                  tenantData?.data?.currency === "INR"
                    ? planData?.data?.ratePerInviteInr
                    : planData?.data?.ratePerInvite
                }
                lastRechargeDate={tenantData?.data?.lastRechargeDate}
                currentCredits={tenantData?.data?.allocatedCredits}
              />
              {isCustomPlanModalOpen && (
                <CreateCustomPlan
                  handleClose={handleCloseCustomPlanModal}
                  isOpen={isCustomPlanModalOpen}
                  tenantId={id}
                  currency={tenantData?.data?.currency}
                />
              )}
            </Row>
          </Col>
        </CardBody>
      </Card>
    </>
  );
}

export default PlanDetails;

const customStyles = {
  control: (provided, state) => ({
    ...provided,
    height: "46px",
    width: "100%",
    fontSize: "14px",
    borderColor: state.isFocused ? "#DEE2E6" : "#DEE2E6",
    boxShadow: state.isFocused ? "0 0 0 1px #DEE2E6" : "none",
    "&:hover": {
      borderColor: "#DEE2E6",
    },
  }),
  menu: (provided) => ({
    ...provided,
    fontSize: "14px",
  }),
  singleValue: (provided) => ({
    ...provided,
    color: "#8898AA",
  }),
  placeholder: (provided) => ({
    ...provided,
    color: "#8898AA",
  }),
};

const styles = {
  header: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
  },
  loaderColor: { color: cyanBlue },
  loaderContainer: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    height: "10vh",
    width: "100%",
  },
  cardStyle: { marginLeft: "0.4rem", marginRight: "0.4rem" },
  iconStyle: {
    cursor: "pointer",
    marginLeft: "8px",
  },
};
